<template>
  <!-- 地址选择 -->
  <div class="address-select">
    <div class="region-tab">
      <div :class="['tab-item', { select: current === 0 }]" @click="changeRegionTab(0)">
        <span>{{ province || '请选择' }}</span>
      </div>
      <div :class="['tab-item', { select: current === 1 }]" v-show="province" @click="changeRegionTab(1)">
        <span>{{ city || '请选择' }}</span>
      </div>
      <div :class="['tab-item', { select: current === 2 }]" v-show="city" @click="changeRegionTab(2)">
        <span>{{ area || '请选择' }}</span>
      </div>
    </div>
    <div class="region-con">
      <div class="con-item" v-for="(item, key) in regionCon" :key="key" @click="changeRegionCon(item)">
        <div
          class="fs-36"
          :class="[
            'item',
            {
              select:
                (current === 0 && item === province) ||
                (current === 1 && item === city) ||
                (current === 2 && item === area)
            }
          ]"
        >
          {{ item }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AddressSelect',
  props: ['getRegionData'],
  computed: {
    regionCon() {
      const getRegionData = this.getRegionData
      const { current } = this
      if (current === 0) return Object.keys(getRegionData)
      else if (current === 1) return Object.keys(getRegionData[this.province])
      else if (current === 2) return getRegionData[this.province][this.city]
    }
  },
  data() {
    return {
      province: '',
      city: '',
      area: '',
      // 0:未选择， 1:已选择省， 2:已选择市， 3:已选择区
      current: 0
    }
  },
  watch: {
    // 监听 area 的变化
    area() {
      const { province, city, area } = this
      if (area) {
        const addressSelectData = {
          province,
          city,
          area
        }
        this.$emit('changeAddress', addressSelectData)
      }
    }
  },
  methods: {
    // 切换地址区域
    changeRegionTab(current) {
      this.current = current
    },
    // 切换地址数据
    changeRegionCon(item) {
      if (this.current === 0) {
        this.province = item
        this.city = ''
        this.area = ''
        this.current++
      } else if (this.current === 1) {
        this.city = item
        this.area = ''
        this.current++
      } else if (this.current === 2) {
        this.area = item
      }
    }
  }
}
</script>

<style scoped lang="scss" src="./index.scss" />
